import { NotificationsSettingPath } from '../../../constants/notifications';
import NotificationSettingEditStore from '../../../stores/notificationSettingEditStore';
import { defaultWalletNotificationSetting } from '../constants';

export const walletNotificationEditStore = new NotificationSettingEditStore(NotificationsSettingPath.WALLET, defaultWalletNotificationSetting);
